import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { selectEntities } from 'services/entities/selectors';
import { selectVarieties } from 'services/varieties/selectors';
import { makeSelectHarvestSchemaValue } from 'services/schemas/selectors';
import { FertilizerEventEntityId } from 'services/fertilizerEvents/types';
import { getEntitiesOptionsWithVariety } from 'utils/events';
import { EntityDropdownOptions } from '../../types';
import { Props } from './index';

const selectOptions = (state: AppState, props: Props): EntityDropdownOptions =>
    props.options;

const selectFertilizerEntityId = (
    state: AppState,
    props: Props
): FertilizerEventEntityId | undefined => props.fertilizerEntityId;

const selectFertilizerInnerEntityOptions = createDeepEqualSelector(
    selectOptions,
    selectEntities,
    selectVarieties,
    selectFertilizerEntityId,
    makeSelectHarvestSchemaValue('entityTypeId'),
    (options, entities, varieties, fertilizerEntityId, harvestEntityTypeId) => {
        if (!fertilizerEntityId) return [];

        return getEntitiesOptionsWithVariety(
            options,
            entities,
            varieties,
            fertilizerEntityId,
            harvestEntityTypeId
        );
    }
);

const makeSelectFertilizerInnerEntityOptions =
    (): typeof selectFertilizerInnerEntityOptions =>
        selectFertilizerInnerEntityOptions;

export { makeSelectFertilizerInnerEntityOptions };
